export default "__VITE_ASSET__MNIBkgA3__"